export const SHARE_TYPE_ALL_SPARKS = 'all-sparks';
export const SHARE_TYPE_ALL_PICKS = 'all-picks';
